// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5a668281","389":"ba3ecaf9","453":"cac3bb8a","455":"1110d2ba","857":"e57a3f66","977":"2bfeedb3"}[chunkId] + ".chunk.js";
};